<template>
  <transition name="slide-styleMsg">
    <div
      class="vipPayment"
      v-if="boxData.judgeBox"
      :style="{
        top: boxData.fix.y + 'px',
        left: boxData.fix.x + 'px',
        'z-index': boxData.Zindex,
      }"
      @click="stopDocument($event)"
    >
      <div
        class="dragArea"
        v-on:mousedown="moveStart($event, true)"
        v-on:mousemove="moveArea($event)"
        v-on:mouseup="saveMoveState($event)"
        :style="{ cursor: boxData.moveoks ? 'move' : 'default' }"
      >
        <span></span>
        <i class="el-icon-close" @click="nextFs();close()"></i>
      </div>
      <div class="vipPaymentBoody">
        <div class="msg">{{ this.boxData.data.msg }}</div>
        <div class="btn">
          <a
            :href="linkUrl.left"
            target="_blank"
            v-if="boxData.data.msgType === 0 || boxData.data.msgType === 1"
          >
            <el-button
              v-if="boxData.data.btnClose"
              @click="
                baiduAnalysisFs('close');
                nextFs();
                close();
              "
              >{{ boxData.data.btnClose }}</el-button
            >
          </a>

          <el-button
            v-if="
              boxData.data.btnClose &&
              (boxData.data.msgType === 2 || boxData.data.msgType === 3)
            "
            @click="
              baiduAnalysisFs('close');
              preverFS();
            "
            >{{ this.boxData.data.btnClose }}</el-button
          >

          <el-button
            v-if="boxData.data.btnMsg && boxData.data.msgType === 0"
            @click="
              baiduAnalysisFs('msg');
              nextFs();
            "
            :class="{
              active: boxData.data.btnMsg,
            }"
            >{{ this.boxData.data.btnMsg }}</el-button
          >

          <a
            :href="linkUrl.right"
            target="_blank"
            v-if="boxData.data.btnMsg && boxData.data.msgType === 1"
          >
            <el-button
              v-if="boxData.data.btnMsg"
              @click="
                baiduAnalysisFs('msg');
                close();
              "
              >{{ boxData.data.btnMsg }}</el-button
            >
          </a>

          <el-button
            v-if="
              boxData.data.btnMsg &&
              (boxData.data.msgType === 2 || boxData.data.msgType === 3)
            "
            @click="
              baiduAnalysisFs('msg');
              nextFs();
            "
            >{{ this.boxData.data.btnMsg }}</el-button
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import popupSecond from "../../mixins/popupSecond";
import Analysis from "../../mixins/analysis/materialBu";

export default {
  mixins: [popupSecond, Analysis],
  data() {
    return {
      boxDataName: "vipPayment", // 弹窗名称
      setIntervalTime: null,
      linkUrl: {
        left: "/workplace/vip",
        right: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "Window_Size",
      "MaterialPane_Size",
      "UserEquity",
      "UserLevel",
      "UserLevelName",
      "IsVipSprites",
    ]),
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
    }),
  },
  watch: {
    "boxDatas.secondData": function (val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.secondData, "vipPayment");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.data = this.dataMsg.vipPayment;
        this.boxData.fix.x = (this.Window_Size.width - 450) / 2;
        this.boxData.fix.y = (this.Window_Size.height - 450) / 2;
        switch (this.boxData.data.msgType) {
          case 0:
            this.linkUrl.left = this.$getWikiLink(
              "https://wiki.laihua.com/basic/useraccount/payProblem.html"
            );
            break;
          case 1:
            this.linkUrl.left = this.$getWikiLink(
              "https://wiki.laihua.com/basic/useraccount/payProblem.html"
            );
            this.linkUrl.right = "/workplace/vip"; // 联系客服
            break;
        }
      } else {
        this.setIntervalTime = clearInterval(this.setIntervalTime);
      }
    },
  },
  props: [],
  mounted() {},
  methods: {
    nextFs() {
      // 右键功能
      switch (this.boxData.data.msgType) {
        case 0:
          if (this.boxData.data.btnMsgFs) {
            this.$store.dispatch('showServiceChat');
            this.close();
          } else {
            this.getUserData();
          }
          break;
        case 2:
          switch (this.boxData.data.fs) {
            case "draw":
              this.$bus.emit("draw_close_vue", { type: true });
              this.close();
              break;
            case "payPriceEvent_vue":
              this.$bus.emit("payPriceEvent_vue", { type: false });
              // this.close();
              this.getUserData(this.boxData.data);
              break;
            case "paySprite":
              this.$bus.emit("payPriceEvent_vue", { type: false });
              break;
          }
          break;
        case 3:
          this.fontPayStatus();
          break;
      }
    },
    preverFS() {
      // 左键功能
      switch (this.boxData.data.msgType) {
        case 2:
          switch (this.boxData.data.fs) {
            case "draw":
              this.$bus.emit("draw_close_vue", { type: false });
              this.close();
              break;
            case "payPriceEvent_vue":
              let _a = document.createElement("a");
              _a.href = this.$getWikiLink(
                "https://wiki.laihua.com/basic/useraccount/payProblem.html"
              );
              _a.target = "_blank";
              _a.click();
              this.close();
              break;
          }
          break;
      }
    },
    getUserData(popupData) {
      const vm = this;
      this.$http.get("/api/session").then((res) => {
        // 请求用户数据
        let userData = res.data.data;

        let fn = () => {
          this.$store.commit("toggle_UserMsg", userData);
          this.$bus.emit("updata_new_draft", { type: true });

          let timeoutid = setTimeout(() => {
            this.$message({
              showClose: true,
              message: "恭喜你，升级为 " + this.UserLevelName,
              type: "success",
            });
            this.$bus.emit("payPriceEvent_vue", { type: false });
            if (popupData.templateCheckId) {
              vm.$modal.show("openTemplate", {
                id: popupData.templateCheckId,
              });
            }
            clearTimeout(timeoutid);
          }, 300);
        };
        console.log("身份等级信息", this.UserLevel, userData.level);

        if (userData.tmpLevelType != null && userData.tmpLevelType > 1) {
          userData.level = userData.tmpLevel;
          userData.levelType = userData.tmpLevelType;
        }

        if (userData.tmpLevelType != null && userData.tmpLevelType === 0) {
          userData.levelType = 0;
          userData.level = userData.tmpLevel;
        }

        if (this.UserLevel != userData.level) {
          // 成功

          if (!userData.isSonAccount) {
            this.$http
              .get("/api/user/account/family/sonList")
              .then((accountData) => {
                accountData = accountData.data.data;
                if (!accountData.length) {
                  delete userData.sonAccount;
                }
                // this.$store.commit("toggle_UserMsg", userData);
                fn();
              });
          } else {
            fn();
          }

          if (this.IsVipSprites.type) {
            for (let i = 0, t = this.IsVipSprites.data.length; i < t; i++) {
              let dataType = this.IsVipSprites.data[i];
              if (
                dataType.type !== "bg" &&
                dataType.type !== "scenes" &&
                dataType.type !== "sound"
              ) {
                let spriteData = this.TOOL.getSpriteIdData(dataType.id);
                if (
                  spriteData &&
                  spriteData.opHelper &&
                  spriteData.opHelper.showHideSvip
                ) {
                  spriteData.opHelper.showHideSvip(false, false, true);
                }
                spriteData = null;
              }
              dataType = null;
            }
          }

          this.$bus.emit("Modal_close_vue", {
            name: "delVip",
          });
        } else {
          // 失败
          let timeoutid = setTimeout(() => {
            let eventName = this.openSubtitle
              ? "subtitlePopup"
              : "FeaturesPop_vue";
            this.$bus.emit(eventName, {
              name: "vipPayment",
              msg: "您的付款还没有成功哦",
              btnClose: "查看帮助", // 左侧按钮信息
              btnMsg: "联系客服", // 右侧按钮信息
              btnMsgFs: 1, // 判断是否有按钮事件1开始
              fs: "payment",
              msgType: 0, // 0--左链接，右按钮；1--双链接；2--双按钮
              type: 2,
            });
            clearTimeout(timeoutid);
          }, 500);
        }
        this.close();
      });
    },
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    baiduAnalysisFs(data) {
      // console.log(this.boxData.data, '<---this.boxData.data')
      if ("actionType" in this.boxData.data) {
        switch (this.boxData.data.actionType) {
          case "autoDraw":
            switch (data) {
              case "close":
                this.materialPushAnalysis({ type: "autodraw4" });
                break;
              case "msg":
                this.materialPushAnalysis({ type: "autodraw5" });
                break;
            }
            break;
        }
      }
    },
    fontPayStatus() {
      let fontId = this.boxData.data.fontId;
      if (fontId) {
        this.$http
          .get(`/api/common/material?style=1&type=6&id=${fontId}`)
          .then((res) => {
            if (res.data.data && res.data.data.tt) {
              this.$message({
                showClose: true,
                message: "恭喜你，字体购买成功",
                type: "success",
              });
              this.$bus.emit("fontPaySuccess", {
                id: fontId,
                tt: res.data.data.tt,
              });
            } else {
              this.$bus.emit("FeaturesPop_vue", {
                name: "vipPayment",
                msg: "您的付款还没有成功哦",
                btnClose: "查看帮助", // 左侧按钮信息
                btnMsg: "联系客服", // 右侧按钮信息
                btnMsgFs: 1, // 判断是否有按钮事件1开始
                fs: "payment",
                msgType: 0, // 0--左链接，右按钮；1--双链接；2--双按钮
                type: 2,
              });
            }
          });
      }
      this.close();
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vipPayment {
  position: fixed;
  top: 63px;
  left: 0;
  width: 500px;
  height: 250px;
  line-height: 34px;
  text-align: left;
  z-index: 9999;
  box-shadow: #d8dee9 0px 0px 5px 0px;
  border-radius: 6px;
  border: 1px solid #d8dee9;
  background: #fff;
  overflow: hidden;
  font-size: 14px;

  .vipPaymentBoody {
    .msg {
      width: 350px;
      height: 150px;
      margin: 0 auto;
      padding: 40px 0 20px 0;
      font-size: 14px;
      text-align: center;
    }

    .btn {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-around;

      .el-button {
        width: 160px;
        background-color: #eaeaf6;
        font-size: 14px;
        font-size: 14px;
        border-color: #eaeaf6;
        border-radius: 8px;
        height: 39px;
      }
      .active {
        background-color: #5778fb;
        color: #fff;
      }
    }
  }
  .dragArea {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 15px;
    height: 28px;
    span {
      width: 80px;
      text-align: left;
      color: #474261;
    }
    i {
      display: inline-block;
      width: 18px;
      height: 18px;
      font-size: 18px;
      cursor: pointer;
    }
  }
}
.slide-styleMsg-enter-active {
  transition: all 0.3s ease;
}
.slide-styleMsg-leave-active {
  transition: all 0.3s ease-in;
}
.slide-styleMsg-enter,
.slide-styleMsg-leave-to {
  transform: translateY(-60px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/vipPopups/vipSprites.vue